<template>
  <GModal class="custom-modal modal--tnc">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" alt="icon-close-modal" @click.prevent="closeModal" />
      </button>
      <h2 class="modal-heading">PRIVACY POLICY</h2>
    </div>
    <div slot="body">
      <div class="body-content">
        <p>
          Kebijakan privasi <strong>(“Kebijakan Privasi”)</strong> ini merupakan suatu komitmen PT. Sociolla Ritel
          Indonesia (<strong>“Perseroan”</strong> atau <strong>“Kami”</strong>) untuk selalu melindungi dan menghargai
          setiap informasi pribadi pengguna situs www.soco.id (<strong>“SOCO”</strong>), www.sociolla.com (“Sociolla”),
          www.beautyjournal.id (<strong>“Beauty Journal”</strong>), aplikasi SOCO by Sociolla
          (<strong>“Aplikasi”</strong>) (secara bersama-sama disebut sebagai <strong>“Situs”</strong>). Kebijakan
          Privasi ini menjelaskan bagaimana kami mengelola, menggunakan, melindungi, dan, dalam beberapa hal,
          mengungkapkan segala informasi dan juga Data Pribadi (sebagaimana didefinisikan dibawah ini) yang anda berikan
          kepada Kami sehubungan dengan penggunaan terhadap Situs, yang mana merupakan suatu kepatuhan Kami terhadap
          peraturan perundang-undangan Republik Indonesia khususnya pada Undang-Undang No. 27 Tahun 2022 tentang
          Perlindungan Data Pribadi, Undang-Undang No. 11 Tahun 2008 tentang Informasi dan Transaksi Elektronik
          sebagaimana telah diubah dengan Undang-Undang No. 19 Tahun 2016 tentang Perubahan atas Undang-Undang No. 11
          Tahun 2008, Peraturan Menteri Komunikasi dan Informatika No. 20 Tahun 2016 tentang Perlindungan Data Pribadi
          Dalam Sistem Elektronik dan peraturan pelaksananya beserta perubahannya dari waktu ke waktu (<strong
            >“Peraturan Perundang-undangan Yang Berlaku”</strong
          >).
        </p>
        <p>
          Dengan mengakses dan menggunakan Situs, anda meskipun selaku pengguna tidak terdaftar dianggap telah membaca,
          memahami, dan memberikan persetujuan kepada Kami atas pengumpulan, pemrosesan, pengungkapan, dan penggunaan
          informasi yang dapat juga mencakup data pribadi anda yang mungkin secara otomatis terdeteksi, terekam atau
          tersimpan saat anda sempat mengakses dan menggunakan Situs kami. Bagi pengguna terdaftar (“Pengguna”, untuk
          menghindari keragu-raguan penggunaan “anda” juga dapat ditujukan kepada pengguna terdaftar), anda dengan ini
          dianggap telah membaca, memahami, dan dengan ini memberikan persetujuannya secara eksplisit memberikan
          persetujuan kepada Kami atas pengumpulan, pemrosesan, pengungkapan, dan penggunaan informasi dan juga data
          pribadi anda sebagaimana diuraikan di bawah ini serta hal-hal lainnya yang diatur dalam Kebijakan Privasi ini
          pada saat pendaftaran akun pertama kali dari waktu ke waktu setiap kali anda bertransaksi atau menggunakan
          Situs kami. Kebijakan Privasi dapat berubah atau diperbaharui sewaktu-waktu dengan adanya pemberitahuan
          terlebih dahulu melalui alamat e-mail pengguna terdaftar, dan Pengguna memiliki kebebasan untuk menyetujui
          atau melakukan penolakan dengan melakukan penghapusan akun. Pengguna dianggap menyetujui perubahan tersebut
          dalam hal Pengguna tetap menggunakan Situs.
        </p>

        <h3 class="subheading">1. PEROLEHAN DATA PRIBADI</h3>
        <p>
          Kami meminta informasi yang dianggap perlu untuk menunjang Situs Kami sewaktu anda mendaftarkan akun untuk
          dapat menggunakan dan mengakses Situs yang merupakan data pribadi bersifat umum dan data pribadi bersifat
          khusus nama, alamat, nomor telepon, alamat e-mail, nomor kartu kredit dan informasi rekening bank, data lokasi
          perangkat, riwayat pengiriman, barang yang terkirim, deskripsi barang yang diminta atau dibeli dan juga
          informasi log yang tersedia di server Kami, alamat protokol internet, informasi aktivitas perangkat, jenis
          peramban, tanggal dan waktu permintaan, URL perunjuk, sistem operasi, serta statistik halaman yang dilihat dan
          informasi lain yang akan berguna atau diperlukan (<strong>“Data Pribadi”</strong>) untuk memberi anda layanan
          terbaik Kami dari Situs.
        </p>
        <p>
          Perlu anda ketahui juga bahwa Aplikasi Kami menggunakan teknologi geofencing untuk meningkatkan pengalaman
          anda. Untuk menghindari keragu-raguan, dengan menggunakan aplikasi kami, anda memberikan persetujuan untuk
          pengumpulan dan penggunaan data lokasi perangkat anda dalam batas-batas virtual yang ditentukan. Anda memiliki
          opsi untuk mengontrol fitur geofencing melalui pengaturan perangkat anda.
        </p>
        <p>
          Melalui penggunaan Situs, Perseroan mengumpulkan, mengolah, menganalisa dan menyimpan Data Pribadi, dengan
          cara sebagai berikut:
        </p>

        <ol type="a" class="privacy-listing">
          <li>
            Data/informasi identitas diri yang diserahkan secara benar, mandiri dan sukarela oleh anda, termasuk namun
            tidak terbatas pada saat anda:
            <ol type="1">
              <li>
                membuat atau mendaftarkan akun untuk dapat menggunakan dan mengakses Situs (<strong>“Pengguna”</strong>)
                dan mengisi formulir yang meminta informasi/data termasuk diantaranya adalah Data Pribadi;
              </li>
              <li>
                mengunjungi halaman situs para mitra tertentu dari Perseroan yang tercantum referensi link-nya di Situs
                Perseroan (jika ada);
              </li>
              <li>
                berkontribusi untuk mengirimkan, mengunggah konten dalam bentuk foto, tulisan, video, pengiriman produk,
                pengiriman pertanyaan, komentar atau tanggapan lainnya mengenai Situs Kami;
              </li>
              <li>
                memberikan feedback kepada Kami melalui e-mail, formulir yang diisi, surat, atau panggilan telepon;
              </li>
              <li>mengaktifkan fitur geofencing melalui pengaturan pada perangkat anda; dan</li>
              <li>
                mengisi data-data pada halaman konfirmasi pembayaran pada Situs pada saat proses pembayaran termasuk
                namun tidak terbatas pada data rekening bank, kartu kredit, virtual account, internet banking, dan jasa
                pembayaran lainnya;
              </li>
            </ol>
          </li>
          <li>
            data yang Kami peroleh melalui media sosial, yaitu termasuk namun tidak terbatas, Instagram Sociolla, dengan
            menekan tombol like Fan Page Kami di Facebook atau saat berinteraksi dengan Kami melalui situs sosial media
            lainnya. Data Pribadi yang kami peroleh dari pihak ketiga terbatas pada nama anda dan tulisan yang anda
            sukai yang tersedia pada laman pihak ketiga tersebut. Data yang kami gunakan terbatas pada mode agregat
            untuk meninjau dan meningkatkan Situs Kami;
          </li>
          <li>
            Data yang Kami peroleh dari pihak ketiga, seperti pihak yang terafiliasi dengan Kami, mitra bisnis, dan
            pihak ketiga lainnya yang independen.
          </li>
          <li>
            Data yang terekam pada saat anda menggunakan Situs, termasuk namun tidak terbatas pada saat anda mengunjungi
            Situs, yang mana Kami dapat memproses data teknis seperti alamat Internet Protocol (IP address) anda.
          </li>
        </ol>
        <p>
          Jangka waktu retensi atas Data Pribadi yang diberikan kepada Kami adalah: a) 10 (sepuluh) tahun sejak Data
          Pribadi kami terima untuk data pribadi yang terkait dengan transaksi keuangan; dan b) 5 (lima) tahun sejak
          Data Pribadi kami terima untuk yang tidak terkait dengan transaksi keuangan atau sampai dengan Pengguna
          meminta penghapusan atas beberapa atau seluruh Data Pribadi dengan tetap memperhatikan ketentuan Peraturan
          Perundang-Undangan Yang Berlaku. Pemrosesan Data Pribadi kami lakukan sejak Data Pribadi diterima oleh Kami
          sampai dengan penghapusan Data Pribadi berdasarkan permintaan dari Pengguna atau sebab lainnya yang tercantum
          di
          <a
            href="/page/termsandconditions#:~:text=KEBIJAKAN%20PENGHENTIAN%2C%20PENUTUPAN%20AKUN%2C%20DAN%20PENGHAPUSAN%20KONTEN"
            target="_blank"
            rel="noopener"
            >SYARAT DAN KETENTUAN</a
          >
          sejauh diperbolehkan Peraturan Perundang-Undangan Yang Berlaku.
        </p>

        <h3 class="subheading">2. PENGGUNAAN DATA PRIBADI</h3>

        <p>
          Data Pribadi anda digunakan dan dilindungi oleh Perseroan sesuai dengan Peraturan Perundang-undangan Yang
          Berlaku dan Kebijakan Privasi ini. Perseroan mengumpulkan informasi Pengguna dengan tujuan antara lain:
        </p>

        <ol type="a" class="privacy-listing">
          <li>memverifikasi data Pengguna yang menggunakan Situs;</li>
          <li>menjamin dan memberikan user interface Situs yang lebih baik;</li>
          <li>
            menyediakan serta mempermudah transaksi pembayaran yang dilakukan oleh Pengguna pada Situs termasuk
            diantaranya dengan proses konfirmasi dan pengiriman pesanan Pengguna;
          </li>
          <li>untuk mengumpulkan data transaksi Pengguna Situs;</li>
          <li>melaksanakan kewajiban Perseroan sehubungan dengan pelaksanaan atas kerjasama dengan pihak ketiga;</li>
          <li>
            untuk kepentingan riset pasar atau pengembangan Situs agar Perseroan dapat meningkatkan Situs, dan/atau
            untuk menyesuaikan situs untuk memberikan Situs dan produk yang paling diminati oleh anda;
          </li>
          <li>
            untuk mengelola sebuah undian, promosi, survei, riset pasar, atau hal relevan lainnya yang bertujuan untuk
            disediakan kepada Pengguna;
          </li>
          <li>
            memfasilitasi komunikasi antara Pengguna dan bagian pelayanan konsumen Perseroan apabila ada permasalahan;
            dan
          </li>
          <li>
            untuk kepentingan publikasi, distribusi, pemasaran dan pengembangan bisnis Perseroan lebih lanjut , termasuk
            penawaran pribadi, promosi, dan notifikasi yang disesuaikan dengan kedekatan perangkat anda yang terdeteksi
            melalui fitur geofencing yang diaktifkan anda dengan lokasi toko kami atau area geografis tertentu
          </li>
        </ol>

        <p>
          Data Pribadi yang anda muat atau telah dimuat harus anda perbaharui atau perbaiki secara berkala dan akurat
          apabila memang ada perubahan atau kesalahan guna memastikan kesinambungan dan keamanan Situs Kami. Anda wajib
          menyediakan informasi sebagaimana diminta oleh Perseroan secara benar dan akurat. Dalam hal terdapat
          ketidakakuratan atau tidak diperbaharuinya Data Pribadi maka Perseroan berhak untuk melakukan penangguhan
          terhadap akun anda sampai anda melakukan perbaikan terhadapnya.
        </p>

        <h3 class="subheading">3. PENGUNGKAPAN DATA PRIBADI PENGGUNA KEPADA PIHAK KETIGA</h3>

        <p>
          Perseroan tidak akan mengalihkan, menjual, mendistribusikan, mengungkapkan atau meminjamkan informasi dan juga
          Data Pribadi anda kepada pihak ketiga lain, kecuali dengan ketentuan-ketentuan sebagai berikut:
        </p>

        <ol type="a" class="privacy-listing">
          <li>
            Perseroan dapat mengalihkan Data Pribadi secara keseluruhan atau sebagian besar kepada pihak ketiga dalam
            hal dilakukannya aksi korporasi termasuk namun tidak terbatas pada penggabungan, peleburan, pengambilalihan,
            atau reorganisasi yang menyebabkan beralihnya penguasaan atau kepemilikan atas Perseroan;
          </li>
          <li>
            apabila Perseroan mengungkapkan informasi tersebut kepada suatu pihak yang telah menandatangani perjanjian
            kerahasiaan dengan Perseroan;
          </li>
          <li>
            apabila Perseroan berkewajiban mengungkapkan dan/atau berbagi data pribadi anda dalam upaya mematuhi
            kewajiban hukum berdasarkan peraturan perundang-undangan yang berlaku;
          </li>
          <li>
            dalam upaya memberlakukan atau menerapkan Syarat dan Ketentuan, atau untuk melindungi hak, properti, atau
            keselamatan Perseroan, Pelanggan, atau pihak lain, termasuk namun tidak terbatas kepada pertukaran informasi
            dan Data Pribadi dengan perusahaan dan organisasi lain untuk tujuan perlindungan Perseroan beserta
            Penggunanya termasuk namun tidak terbatas pada permasalahan penipuan, kerugian finansial atau pengurangan
            resiko lainnya;
          </li>
          <li>
            dalam rangka memberikan ulasan atau review yang diberikan Pengguna atas produk yang yang tersedia pada
            Situs. Ketika anda telah menyelesaikan pembelian anda terhadap suatu produk pada Situs Kami, anda akan kami
            undang untuk memberikan ulasan atas produk tersebut. Dengan memberikan ulasannya, Pengguna setuju bahwa
            ulasan tersebut dapat ditampilkan pada Situs Kami, Aplikasi Kami, akun sosial media Kami, atau penyedia
            Situs yang relevan dengan Kami atau situs pihak ketiga lainnya yang bermitra dengan Kami;
          </li>
          <li>
            kerjasama Perseroan dengan mitra bisnis atau pihak ketiga lainnya dengan memberikan akses atas Data Pribadi
            terhadap pihak-pihak yang bekerja dan memberikan layanan untuk pemeliharaan, pengembangan Situs dan
            layanan-layanan lainnya yang relevan.
          </li>
          <li>
            Kami dapat membagikan informasi non-pribadi yang dapat teridentifikasi kepada publik dan mitra Kami, seperti
            penayang, pengiklan, atau situs lain yang relevan. Kami dapat membagikan informasi yang tersedia secara
            publik untuk menunjukkan tren mengenai penggunaan umum atas Situs Kami.
          </li>
          <li>
            Kami dapat mengungkapkan kepada pihak ketiga lainnya yang bertindak sebagai penyedia jasa Kami untuk
            membantu Kami menyediakan layanan kepada Pengguna. Penyedia jasa tersebut termasuk kepada penyedia layanan
            konsumen (customer service), dan penyedia layanan transaksi pembayaran.
          </li>
          <li>
            Kami dapat membagikan informasi Data Pribadi kepada pihak ketiga lainnya untuk menunjang kebutuhan Kami
            dalam rangka meningkatkan dan mengembangkan kepentingan pemasaran dan pengembangan bisnis Perseroan.
          </li>
        </ol>

        <p>
          Kami akan selalu berusaha dengan upaya terbaik kami untuk menjaga Data Pribadi termasuk ketika kami memberikan
          Data Pribadi kepada pihak ketiga lainnya. Namun, tidak dalam hal apapun Sociolla dapat menjamin penggunaan dan
          pengelolaan Data Pribadi, sehingga sepenuhnya menjadi tanggung jawab pihak ketiga. Pengguna dengan ini setuju
          untuk membebaskan Perseroan jika terjadi penyalahgunaan Data Pribadi yang dilakukan oleh pihak ketiga.
        </p>

        <h3 class="subheading">4. HAK PEMILIK DATA PRIBADI</h3>

        <p>
          Kami memiliki database yang memungkinkan Pengguna Situs untuk menyimpan informasi mengenai penagihan,
          pengiriman barang, pembayaran, melacak status dari pesanan pengguna, informasi terkait kartu kredit, daftar
          transaksi sebelumnya, alamat e-mail dan beberapa Data Pribadi lainnya.
        </p>
        <p>Anda memiliki hak untuk:</p>
        <ul>
          <li>
            mengakses informasi dan untuk meminta koreksi atas informasi tersebut. Jika anda ingin mengakses atau
            memperbaiki Data Pribadi anda, anda dapat melakukannya menggunakan cara yang Kami sediakan pada
            masing-masing Situs;
          </li>
          <li>menarik kembali persetujuan pemrosesan Data Pribadi;</li>
          <li>
            mengakhiri pemrosesan, menghapus, dan/atau memusnahkan Data Pribadi sesuai dengan Peraturan
            Perundang-Undangan;
          </li>
          <li>
            hak-hak lainnya yang diatur oleh Undang-Undang No. 27 Tahun 2022 tentang Perlindungan Data Pribadi sesuai
            dengan tata cara yang diatur di dalamnya serta segala perubahannya dari waktu ke waktu (jika ada).
          </li>
        </ul>
        <p>
          Kecuali untuk poin a di atas, Pengguna dapat menjalankan haknya di atas dengan cara mengirimkan pemberitahuan
          tertulis yang ditujukan ke alamat korespondensi sebagimana tertera di Kebijakan Privasi ini, yang mana
          pemberitahuan tersebut berisi identitas Pengguna (nama, alamat, nomor KTP dan alamat email atau username yang
          digunakan untuk akun pada Situs) hak yang akan digunakan, alasan penggunaan hak, serta diberikan tanda tangan
          terhadapnya serta dengan melampirkan fotocopy KTP. Kami berhak menolak pelaksanaan hak tersebut dalam hal Kami
          menilai terdapat ketidaksesuaian identitas dan/atau penolakan dari kami tersebut merupakan upaya Kami untuk
          patuh terhadap Peraturan Perundang-undangan.
        </p>
        <h3 class="subheading">5. MENARIK PERSETUJUAN, MENGHAPUS, PENUNDAAN SERTA PEMBATASAN DATA PRIBADI</h3>

        <p>
          Anda dapat menarik persetujuan, menghapus, menunda atau melakukan pembatasan atas penggunaan dan/atau
          pemrosesan Data Pribadi dari Situs dengan cara menyampaikan permintaan secara tertulis tersebut ke alamat
          sebagimana tertera di Kebijakan Privasi ini. Seluruh Data Pribadi yang masih ada pada Kami tetap akan
          digunakan sesuai dengan ketentuan Kebijakan Privasi ini.
        </p>

        <p>
          Dengan ditariknya persetujuan, permintaan penghapusan, penundaan atau pembatasan pemrosesan Data Pribadi, Kami
          mungkin:
        </p>

        <ol type="a" class="privacy-listing">
          <li>tidak dapat lagi memberikan layanan kepada anda;</li>
          <li>
            tidak dapat menghapus seluruh data atau informasi yang telah tersedia atau dipublikasikan pada Situs,
            termasuk namun tidak terbatas kepada hasil ulasan/reviewPengguna, riwayat transaksi Pengguna, barang yang
            terkirim, deskripsi barang yang diminta atau dibeli dan juga informasi log yang tersedia di server Kami.
          </li>
          <li>
            tidak dapat menggunakan Data Pribadi sejak ditariknya persetujuan atas penggunaan Data Pribadi, namun kami
            tidak menjamin atas penggunaan Data Pribadi yang sudah diberikan oleh Pengguna sebelum ditariknya
            persetujuan tersebut.
          </li>
        </ol>

        <p>
          Dengan ini anda setuju bahwa Perseroan akan dibebaskan dari tanggung jawab atas kehilangan, kerusakan,
          kerugian yang mungkin timbul akibat penarikan persetujuan dan penghapusan Data Pribadi pada Situs Kami.
        </p>

        <h3 class="subheading">6. COOKIES</h3>

        <p>
          Perseroan dapat menggunakan berbagai macam teknologi untuk mengumpulkan dan menyimpan informasi saat anda
          menggunakan dan mengakses Situs, yang mana teknologi tersebut dapat mencakup penggunaan cookies atau teknologi
          serupa. Cookies adalah file kecil yang secara otomatis akan mengambil tempat di dalam perangkat komputer anda
          untuk mengindentifikasi dan memantau koneksi jaringan anda, sehingga memungkinkan anda untuk menggunakan dan
          mengakses Situs secara optimal. Cookies juga secara otomatis akan membantu sistem kami untuk mengetahui
          browser apa yang anda gunakan dan dapat memberikan anda layanan tambahan seperti misalnya penyimpanan data
          mengenai apa saja yang telah anda beli melalui Situs kami.
        </p>
        <br />
        <h3 class="subheading">7. KORESPONDENSI</h3>
        <p>
          Segala pemberitahuan dari Kami kepada Pengguna sehubungan dengan Kebijakan Privasi ini akan kami kirimkan
          melalui e-mail yang terdaftar pada akun Pengguna, Situs, ataupun sistem elektronik lainnya yang Pengguna
          gunakan untuk mendapatkan layanan kami. Pemberitahuan dianggap telah diterima oleh Pengguna dalam jangka waktu
          2 (dua) jam setelah penerimaan melalui e-mail. Kecuali untuk alamat penggunaan hak sebagaimana dimaksud pada
          Pasal 4 di atas, Pengguna dapat memberikan pemberitahuan kepada Kami melalui alamat Customer Care yang tertera
          pada Situs. Secara khusus untuk pemberitahuan dalam penggunaan hak sebagaimana dimaksud pada Pasal 4 di atas,
          pengguna dapat melakukan pengiriman pemberitahuan tertulis ke St. Moritz Office Tower, Unit 0501, Puri Indah
          CBD Blok U1, Jalan Puri Indah Raya, Desa/Kelurahan Kembangan Selatan, Kec. Kembangan, Kota Adm. Jakarta Barat,
          Provinsi DKI Jakarta, 11610.
        </p>
        <br />
        <h3 class="subheading">8. TAMPILAN IKLAN</h3>

        <p>
          Iklan yang muncul dalam situs Situs berasal dari kami atau pengiklan lainnya sebagai pihak ketiga. Pengiklan
          pihak ketiga tersebut dapat menggunakan cookies yang diselenggarakan oleh server iklan pihak ketiga lainnya
          untuk mengenali perangkat komputer anda setiap kali mereka menampilkan iklan secara online. Dengan demikian,
          server-server iklan tersebut dapat mengumpulkan informasi. Informasi tersebut memungkinkan pengiklan untuk
          mengirim iklan-iklan tertentu yang dianggapnya menarik untuk anda.
        </p>

        <p>
          Kebijakan privasi ini hanya berlaku untuk cookies yang ditempatkan oleh kami dan tidak berlaku kepada cookies
          pengiklan pihak ketiga.
        </p>

        <br />

        <h3 class="subheading">9. KEAMANAN DATA PRIBADI</h3>

        <p>
          Kami bekerja keras untuk melindungi Data Pribadi anda dari akses yang ilegal, khususnya dengan memberikan
          perlindungan kepada anda berdasarkan ketentuan-ketentuan sebagai berikut:
        </p>

        <ol type="a" class="privacy-listing">
          <li>Kami mengenkripsi sejumlah Situs menggunakan Secure Socket Layers.</li>
          <li>
            Kami meninjau praktik-praktik seputar pengumpulan, penyimpanan, dan pemrosesan informasi, termasuk langkah
            keamanan teknis dan fisik, untuk melindungi sistem dari akses yang tidak sah.
          </li>
          <li>
            Dengan memperhatikan ketentuan Pasal 3, Kami membatasi akses ke Data Pribadi hanya kepada karyawan Kami,
            kontraktor, agen yang perlu mengetahui Data Pribadi, atau yang tunduk pada kewajiban perjanjian kerahasiaan
            yang tegas, serta pihak ketiga lainnya berdasarkan ketentuan pada kebijakan privasi ini.
          </li>
        </ol>

        <p>
          Kami mengambil langkah-langkah teknis, wajib, dan administratif yang dirancang untuk melindungi Data Pribadi
          anda. Kami menjaga pengamanan fisik, elektronik, dan prosedural yang berkaitan dengan pengumpulan,
          penyimpanan, dan pengungkapan Data Pribadi anda. Prosedur keamanan kami mewajibkan Kami untuk meminta bukti
          identitas anda sebelum kami mengungkapkan Data Pribadi kepada anda. Anda juga bertanggung jawab untuk membantu
          melindungi keamanan Data Pribadi anda seperti untuk tidak pernah memberikan kata sandi anda kepada pihak
          ketiga lainnya, dan untuk keluar dari akun anda setelah anda selesai menggunakan Situs.
        </p>

        <p>
          Apabila tidak didefinisikan secara khusus di dalam kebijakan ini, istilah-istilah yang didefinisikan dan
          digunakan di dalam Syarat dan Ketentuan Umum Penggunaan dan Akses dan/atau kebijakan lainnya sebagaimana
          terdapat di dalam atau terkait dengan Situs.
        </p>
      </div>
    </div>
  </GModal>
</template>
<script>
export default {
  name: 'modal-provacypolicy',
  data() {
    return {
      active: true,
    };
  },
  methods: {
    closeModal() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'privacyPolicy' });
    },
  },
};
</script>
<style lang="scss">
@import 'privacy-policy';

h3 {
  width: 100%;
  display: block;
}
</style>
